import { render, staticRenderFns } from "./DynamicFormRenderer.vue?vue&type=template&id=f2bb29a6&scoped=true"
import script from "./DynamicFormRenderer.vue?vue&type=script&lang=js"
export * from "./DynamicFormRenderer.vue?vue&type=script&lang=js"
import style0 from "./DynamicFormRenderer.vue?vue&type=style&index=0&id=f2bb29a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bb29a6",
  null
  
)

export default component.exports